import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CusHttp } from './CusHttp';
// import { URLSearchParams } from "@angular/http";

// 未读消息数量 v1/notices/unread-count
const UNREDCOUNT_URL = 'v1/notices/unread-count';
// 获取登录用户的通知列表接口 v1/notices/get-notifications
const NOTIFICATIONSLIST_URL = 'v1/notices/get-notifications';
//删除消息接口 v1/notices/del-notifications
const DELETENOTICE_URL = "v1/notices/del-notifications";
//设置已读消息  v1/notices/read-notifications
const ISREADEDNOTICE_URL = 'v1/notices/read-notifications';
@Injectable()
export class NotificationService {
  notiList;

  constructor(private _http: CusHttp) { }

  /**
   * 获取未读通知数量
   * @memberof NotificationService
   */
  public getUnreadCount() {
    let url = UNREDCOUNT_URL;
    return this._http.get(url);
  }

  /**
   * 获取登录用户的通知列表
   * @param {number} pageIndex
   * @returns {Observable<T>}
   * @memberof NotificationService
   */
  public getList(page: number) {
    let url = NOTIFICATIONSLIST_URL + `?page=${page ? page : ''}`;
    return this._http.get(url);
  }
  // public getList(pageIndex: number): Observable<any> {
  //   let ret = [];
  //   // return this._http.get('aaa');
  // }
  /**
   * 获取通知详情
   *
   * @param {number} id
   * @memberof NotificationService
   */
  public getDetail(id: number) {

  }
  // 设置已读
  public setReaded(id: number) {

  }

  // 批量设置已读 ids不传时全部设置已读。
  public setReadedAll(ids?: Array<number>) {
    let URL = ISREADEDNOTICE_URL;
    return this._http.post(URL, null);
  }

  // 删除通知
  public delete(id: any) {
    let URL = DELETENOTICE_URL;
    let a = new FormData();
    a.append( 'ids', id );
    return this._http.post(URL, a);
  }

  // 批量删除
  public deleteAll(ids: Array<number>) {

  }

  // 发送通知
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/services/notification.service.ts